(function(){
  'use strict';
  var $ = function(s,c){return (c||document).querySelector(s)};
  var $$ = function(s,c){return Array.from((c||document).querySelectorAll(s))};

  /* ---------- Mobile menu toggle ---------- */
  document.addEventListener('click',function(e){
    var t=e.target.closest('[data-nav-toggle]');
    if(t){$$('.hdr__nav').forEach(function(n){n.classList.toggle('is-open')});}
    var st=e.target.closest('[data-sub-toggle]');
    if(st){
      e.preventDefault();
      var item=st.closest('.hdr__item');
      var wasOpen=item.classList.contains('is-open');
      $$('.hdr__item.is-open').forEach(function(i){if(i!==item)i.classList.remove('is-open');});
      item.classList.toggle('is-open',!wasOpen);
      st.setAttribute('aria-expanded',String(!wasOpen));
    } else if(!e.target.closest('.hdr__sub')){
      $$('.hdr__item.is-open').forEach(function(i){
        i.classList.remove('is-open');
        var b=i.querySelector('[data-sub-toggle]'); if(b)b.setAttribute('aria-expanded','false');
      });
    }
    var x=e.target.closest('[data-pop-close]');
    if(x){var p=$('.pop');if(p){p.removeAttribute('open-modal');localStorage.setItem('rw_popup','1');}}
  });

  /* ---------- Discount popup ---------- */
  var pop=$('.pop');
  if(pop && !localStorage.getItem('rw_popup')){
    setTimeout(function(){pop.setAttribute('open-modal','');},parseInt(pop.dataset.delay||'4000',10));
  }

  /* ---------- Variant switching on PDP ---------- */
  $$('[data-variant-form]').forEach(function(form){
    form.addEventListener('change',function(){
      var opts=Array.from(form.querySelectorAll('[data-opt]')).map(function(s){return s.value});
      var variants=JSON.parse(form.querySelector('[data-variants]').textContent);
      var match=variants.find(function(v){return v.options.join('|')===opts.join('|')});
      var idIn=form.querySelector('[name="id"]');
      var btn=form.querySelector('[data-add]');
      var price=$('[data-price]');
      if(match){idIn.value=match.id;btn.disabled=!match.available;btn.textContent=match.available?(btn.dataset.add||'Añadir a la bolsa'):(btn.dataset.sold||'Agotado');
        if(price&&match.price_formatted)price.textContent=match.price_formatted;}
    });
  });

  /* ---------- PDP gallery carousel ---------- */
  $$('[data-gallery]').forEach(function(gal){
    var slides=$$('[data-gal-slide]',gal);
    var thumbs=$$('[data-gal-thumb]',gal);
    var track=$('[data-gal-track]',gal);
    if(!slides.length)return;
    var idx=0;
    var isMobile=function(){return window.matchMedia('(max-width:900px)').matches;};
    function go(i){
      idx=(i+slides.length)%slides.length;
      if(isMobile()){
        if(track&&slides[idx])track.scrollTo({left:slides[idx].offsetLeft,behavior:'smooth'});
      }else{
        slides.forEach(function(s,n){s.classList.toggle('is-active',n===idx);});
      }
      thumbs.forEach(function(t,n){t.classList.toggle('is-active',n===idx);});
    }
    thumbs.forEach(function(t){
      t.addEventListener('click',function(){go(parseInt(t.getAttribute('data-gal-thumb'),10)||0);});
    });
    var prev=$('[data-gal-prev]',gal),next=$('[data-gal-next]',gal);
    if(prev)prev.addEventListener('click',function(){go(idx-1);});
    if(next)next.addEventListener('click',function(){go(idx+1);});

    /* variant -> featured image */
    var mapEl=document.querySelector('[data-variant-images]');
    var form=document.querySelector('[data-variant-form]');
    if(mapEl&&form){
      var map={};
      try{JSON.parse(mapEl.textContent||'[]').forEach(function(p){map[p[0]]=p[1];});}catch(e){}
      form.addEventListener('change',function(){
        var idIn=form.querySelector('[name="id"]');
        if(!idIn)return;
        var imgId=map[idIn.value];
        if(!imgId)return;
        var target=slides.findIndex(function(s){return s.getAttribute('data-image-id')===String(imgId);});
        if(target>-1)go(target);
      });
    }
  });

  /* ============ CART DRAWER (AJAX) ============ */
  var drawer=$('[data-cart-drawer]');
  var overlay=$('[data-cart-overlay]');
  var isOpen=false;

  function openCart(){
    if(!drawer)return;
    isOpen=true;drawer.classList.add('cd--open');overlay.classList.add('cd-overlay--open');
    document.body.style.overflow='hidden';
  }
  function closeCart(){
    if(!drawer)return;
    isOpen=false;drawer.classList.remove('cd--open');overlay.classList.remove('cd-overlay--open');
    document.body.style.overflow='';
  }
  function toggleCart(){isOpen?closeCart():openCart();}

  /* Render updated cart HTML returned by Shopify section rendering API */
  function renderCart(html){
    var tmp=document.createElement('div');tmp.innerHTML=html;
    var items=$('[data-cart-items]',tmp);if(items)$('[data-cart-items]').innerHTML=items.innerHTML;
    var foot=$('[data-cart-foot]',tmp);
    if(foot){
      var sub=$('[data-cart-subtotal]',foot);if(sub && $('[data-cart-subtotal]'))$('[data-cart-subtotal]').textContent=sub.textContent;
    }
    var count=$('[data-cart-count]',tmp);
    if(count){$$('[data-cart-count]').forEach(function(el){el.textContent=count.textContent;});}
  }

  /* Use the /cart.js approach for reliable state + manual render */
  function fetchCart(){
    return fetch('/cart.js',{headers:{'Accept':'application/json'}})
      .then(function(r){return r.json();});
  }

  function formatMoney(cents){
    // Shopify money formatting fallback — uses theme money format if available
    if(window.Shopify && window.Shopify.money_format){
      return window.Shopify.formatMoney && window.Shopify.formatMoney(cents,window.Shopify.money_format)||('$'+(cents/100).toFixed(0));
    }
    return '$'+(cents/100).toLocaleString('es-CO');
  }

  function renderFromCart(cart){
    var itemsEl=$('[data-cart-items]');
    if(!itemsEl)return;
    if(cart.item_count===0){
      itemsEl.innerHTML='<p class="cd__empty">Tu bolsa está vacía.</p><a class="btn btn--ghost cd__shop" href="/collections/all" data-cart-continue>Ir a la tienda</a>';
    }else{
      itemsEl.innerHTML=cart.items.map(function(it){
        var img=it.image?it.image:'';
        return '<div class="cd__item" data-cart-item data-line="'+(it.line_number||'')+'" data-variant-id="'+it.variant_id+'">'
          +'<a href="'+it.url+'" class="cd__item-img"><img src="'+img+'" alt="'+(it.title||'').replace(/"/g,'"')+'" width="84" height="112" loading="lazy"></a>'
          +'<div class="cd__item-info">'
          +'<a href="'+it.url+'" class="cd__item-title">'+(it.product_title||it.title)+'</a>'
          +(it.variant_title && it.variant_title!=='Default Title'?'<div class="cd__item-variant">'+it.variant_title+'</div>':'')
          +'<div class="cd__item-price">'+formatMoney(it.final_price)+'</div>'
          +'<div class="cd__qty"><button class="cd__qty-btn" data-qty-minus type="button" aria-label="Restar">&minus;</button>'
          +'<input class="cd__qty-input" type="number" min="0" value="'+it.quantity+'" data-qty-input>'
          +'<button class="cd__qty-btn" data-qty-plus type="button" aria-label="Sumar">&plus;</button></div>'
          +'</div>'
          +'<button class="cd__remove" data-cart-remove aria-label="Quitar">Quitar</button>'
          +'</div>';
      }).join('');
    }
    var sub=$('[data-cart-subtotal]');if(sub)sub.textContent=formatMoney(cart.total_price);
    $$('[data-cart-count]').forEach(function(el){el.textContent=cart.item_count;el.classList.toggle('is-empty',cart.item_count===0);});
  }

  /* Add to cart (AJAX) */
  function addToCart(formData){
    return fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:formData})
      .then(function(r){return r.json();})
      .then(function(){return fetchCart();})
      .then(function(cart){renderFromCart(cart);openCart();return cart;});
  }

  /* Change line quantity */
  function changeCart(line,quantity){
    return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({line:line,quantity:quantity})})
      .then(function(r){return r.json();})
      .then(function(cart){renderFromCart(cart);return cart;});
  }

  /* Intercept product forms -> AJAX add */
  document.addEventListener('submit',function(e){
    var form=e.target.closest('[data-variant-form]');
    if(!form)return;
    e.preventDefault();
    var btn=form.querySelector('[data-add]');
    if(btn&&btn.disabled)return;
    var fd=new FormData(form);
    var data=new FormData();
    data.append('id',fd.get('id'));
    data.append('quantity',fd.get('quantity')||1);
    if(btn){btn.textContent='Añadiendo...';}
    addToCart(data).then(function(){
      if(btn){btn.textContent=btn.dataset.add||'Añadir a la bolsa';}
    }).catch(function(){
      if(btn){btn.textContent=btn.dataset.add||'Añadir a la bolsa';}
    });
  });

  /* Drawer open/close + quantity controls (event delegation) */
  document.addEventListener('click',function(e){
    var open=e.target.closest('[data-cart-open]');
    if(open){e.preventDefault();openCart();return;}
    var close=e.target.closest('[data-cart-close]');
    if(close){closeCart();return;}
    if(e.target===overlay){closeCart();return;}
    var cont=e.target.closest('[data-cart-continue]');
    if(cont){closeCart();return;}

    var item=e.target.closest('[data-cart-item]');
    if(item){
      var line=parseInt(item.getAttribute('data-line'),10)||0;
      var input=$('[data-qty-input]',item);
      if(e.target.closest('[data-qty-plus]')){changeCart(line,parseInt(input.value,10)+1);}
      if(e.target.closest('[data-qty-minus]')){var q=Math.max(0,parseInt(input.value,10)-1);changeCart(line,q);}
      if(e.target.closest('[data-cart-remove]')){changeCart(line,0);}
    }
  });

  /* Direct quantity input change */
  document.addEventListener('change',function(e){
    var input=e.target.closest('[data-qty-input]');
    if(!input)return;
    var item=input.closest('[data-cart-item]');
    if(!item)return;
    var line=parseInt(item.getAttribute('data-line'),10)||0;
    var q=Math.max(0,parseInt(input.value,10)||0);
    changeCart(line,q);
  });

  /* Escape closes drawer */
  document.addEventListener('keydown',function(e){
    if(e.key==='Escape'&&isOpen){closeCart();}
  });

  /* Re-map line numbers after each render so /cart/change.js line indexes stay valid */
  function relabelLines(){
    $$('[data-cart-item]').forEach(function(el,i){el.setAttribute('data-line',i+1);});
  }

  // On load, relabel existing server-rendered items
  relabelLines();

  // Patch renderFromCart to relabel after rendering
  var _origRender=renderFromCart;
  renderFromCart=function(cart){_origRender(cart);relabelLines();};

})();


/* ============ PRODUCT RECOMMENDATIONS + RECENTLY VIEWED ============ */
(function(){
  'use strict';
  var $=function(s,c){return (c||document).querySelector(s)};
  var $$=function(s,c){return Array.from((c||document).querySelectorAll(s))};

  function setupRail(root){
    var rail=$('[data-rw-rail]',root);
    if(!rail)return;
    var prev=$('[data-rw-prev]',root),next=$('[data-rw-next]',root);
    function sync(){
      var scrollable=rail.scrollWidth>rail.clientWidth+4;
      if(prev)prev.hidden=!scrollable;
      if(next)next.hidden=!scrollable;
    }
    if(prev)prev.addEventListener('click',function(){rail.scrollBy({left:-rail.clientWidth,behavior:'smooth'})});
    if(next)next.addEventListener('click',function(){rail.scrollBy({left:rail.clientWidth,behavior:'smooth'})});
    window.addEventListener('resize',sync);
    sync();
  }

  /* --- Recommendations API --- */
  $$('[data-product-recs]').forEach(function(el){
    var url=el.getAttribute('data-url');
    if(!url)return;
    fetch(url).then(function(r){return r.text()}).then(function(html){
      var doc=new DOMParser().parseFromString(html,'text/html');
      var inner=doc.querySelector('[data-product-recs]');
      if(!inner||!inner.innerHTML.trim())return;
      el.innerHTML=inner.innerHTML;
      setupRail(el);
    }).catch(function(){});
  });

  /* --- Recently viewed --- */
  var KEY='rw_recently_viewed';
  var rv=$('[data-recently-viewed]');
  var current=rv?rv.getAttribute('data-handle'):null;
  if(current){
    var list=[];
    try{list=JSON.parse(localStorage.getItem(KEY)||'[]')||[]}catch(e){list=[]}
    list=list.filter(function(h){return h&&h!==current});
    list.unshift(current);
    try{localStorage.setItem(KEY,JSON.stringify(list.slice(0,8)))}catch(e){}
    var limit=parseInt(rv.getAttribute('data-limit'),10)||4;
    var handles=list.filter(function(h){return h!==current}).slice(0,limit);
    if(handles.length){
      Promise.all(handles.map(function(h){
        return fetch('/products/'+h+'.js').then(function(r){return r.ok?r.json():null}).catch(function(){return null});
      })).then(function(products){
        var items=products.filter(Boolean);
        if(!items.length)return;
        var rail=$('[data-rw-rail]',rv);
        rail.innerHTML=items.map(function(p){
          var img=p.featured_image?p.featured_image:(p.images&&p.images[0])||'';
          var price=(window.Shopify&&window.Shopify.formatMoney)?window.Shopify.formatMoney(p.price):('$'+(p.price/100).toLocaleString('es-CO'));
          return '<div class="rw-rail__item"><a class="card" href="'+p.url+'">'
            +'<div class="card__media">'+(img?'<img src="'+img+'" alt="'+(p.title||'').replace(/"/g,'&quot;')+'" width="900" height="1200" loading="lazy">':'')+'</div>'
            +(p.vendor?'<p class="card__v" style="margin-top:12px">'+p.vendor+'</p>':'')
            +'<p class="card__t">'+p.title+'</p>'
            +'<p class="card__p">'+price+'</p>'
            +'</a></div>';
        }).join('');
        rv.hidden=false;
        setupRail(rv);
      });
    }
  }
})();
/* infinite scroll de colección */
(function(){
  var zone=document.querySelector('[data-rw-infinite]');
  var grid=document.querySelector('[data-rw-infinite-grid]');
  if(!zone||!grid||!window.fetch)return;
  zone.classList.add('is-auto');
  var loading=false;
  function nextLink(){return zone.querySelector('[data-rw-infinite-next]')}
  function load(){
    var link=nextLink();
    if(!link||loading)return;
    loading=true;
    var spin=zone.querySelector('[data-rw-infinite-loading]');
    if(spin)spin.hidden=false;
    fetch(link.href).then(function(r){return r.text()}).then(function(html){
      var doc=new DOMParser().parseFromString(html,'text/html');
      var newGrid=doc.querySelector('[data-rw-infinite-grid]');
      var newZone=doc.querySelector('[data-rw-infinite]');
      if(newGrid){while(newGrid.firstElementChild){grid.appendChild(newGrid.firstElementChild)}}
      zone.innerHTML=newZone?newZone.innerHTML:'';
      loading=false;
      check();
    }).catch(function(){loading=false;if(spin)spin.hidden=true});
  }
  function check(){
    var link=nextLink();
    if(!link)return;
    var r=zone.getBoundingClientRect();
    if(r.top<window.innerHeight*1.5)load();
  }
  zone.addEventListener('click',function(e){
    var a=e.target.closest('[data-rw-infinite-next]');
    if(a){e.preventDefault();load()}
  });
  window.addEventListener('scroll',check,{passive:true});
  window.addEventListener('resize',check);
  check();
})();
